import { cn } from '@app/utils/cn';
import React from 'react';

interface Props {
  className?: string;
  isSelected?: boolean;
  isFocusTarget?: boolean;
  dataTestId?: string;
  wrapperClassName?: string;
  style?: React.CSSProperties;
}

export const RegularSummaryCell = React.forwardRef<HTMLDivElement, React.WithOptionalChildren<Props>>((props, ref) => {
  const { children, className, isSelected, isFocusTarget, dataTestId, wrapperClassName, style } = props;

  return (
    <th
      data-testid={dataTestId}
      className={cn('select-none border-2 border-transparent bg-white p-0 transition-colors touch:select-auto', wrapperClassName)}
      style={style}
    >
      {/* tabIndex is neccessary to allow proper keyboard navigation */}
      <div
        ref={ref}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={0}
        data-focus-target={isFocusTarget}
        className={cn(
          'flex h-10 items-center justify-center rounded-regular border border-transparent px-2 focus:outline-none',
          {
            'border-info-62': isSelected,
          },
          className,
        )}
      >
        {children}
      </div>
    </th>
  );
});
